import React from 'react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="bg-white pt-20 pb-12 px-6 md:px-12 lg:px-24" data-id="element-96">
      <div className="max-w-4xl mx-auto text-center" data-id="element-97">
        <FadeIn data-id="element-98">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-text-black leading-tight mb-8" data-id="element-99">
            ¿Y si tu dolor articular no es desgaste... sino un fuego silencioso
            que puedes apagar desde tu cocina?
          </h1>
        </FadeIn>
        <FadeIn delay={0.2} data-id="element-100">
          <p className="text-xl md:text-2xl text-text-gray font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-101">
            Descubre el protocolo de 7 días que miles de mujeres mayores de 55
            están usando para recuperar su movilidad sin pastillas, sin
            inyecciones y sin suplementos caros
          </p>
        </FadeIn>
      </div>
    </section>;
}